export const audioExt = ["mp3", "ogg", "mpeg"];

export const imageExt = ["jpg", "jpeg", "gif", "png", "xlsx", "xls"];

export const videoExt = ["mp4", "MOV", "WMV", "AVI", "MKV", "WEBM"];

export const resourceExt = ["pdf"];
